import { render, staticRenderFns } from "./newproduct.vue?vue&type=template&id=852ca67e&scoped=true&"
import script from "./newproduct.vue?vue&type=script&lang=js&"
export * from "./newproduct.vue?vue&type=script&lang=js&"
import style0 from "./newproduct.vue?vue&type=style&index=0&id=852ca67e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852ca67e",
  null
  
)

export default component.exports